/**
 * Two related hover interactions on product cards, driven by the same
 * mousemove so they read as one cohesive effect rather than two competing
 * ones: the image tilts in 3D toward the cursor (with its existing zoom
 * folded in), and the whole card gets a subtle magnetic pull.
 *
 * Desktop (hover + fine pointer) only, skipped under prefers-reduced-motion.
 */
import { motionEnabled } from '@theme/premium-motion';

const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

if (motionEnabled && supportsHover && typeof gsap !== 'undefined') {
  document.documentElement.classList.add('flv-js-tilt-active');

  document.querySelectorAll('.flv-product-card').forEach((el) => {
    const card = /** @type {HTMLElement} */ (el);
    const image = card.querySelector('.flv-product-card__image');
    if (!image) return;

    gsap.set(image, { transformPerspective: 800 });

    const tiltX = gsap.quickTo(image, 'rotationX', { duration: 0.4, ease: 'power3' });
    const tiltY = gsap.quickTo(image, 'rotationY', { duration: 0.4, ease: 'power3' });
    const zoom = gsap.quickTo(image, 'scale', { duration: 0.4, ease: 'power3' });
    const pullX = gsap.quickTo(card, 'x', { duration: 0.4, ease: 'power3' });
    const pullY = gsap.quickTo(card, 'y', { duration: 0.4, ease: 'power3' });

    card.addEventListener('mousemove', (/** @type {MouseEvent} */ event) => {
      const rect = card.getBoundingClientRect();
      const relX = (event.clientX - rect.left) / rect.width - 0.5;
      const relY = (event.clientY - rect.top) / rect.height - 0.5;

      tiltY(relX * 12);
      tiltX(relY * -12);
      zoom(1.05);
      pullX(relX * 6);
      pullY(relY * 6 - 5);
    });

    card.addEventListener('mouseleave', () => {
      tiltX(0);
      tiltY(0);
      zoom(1);
      pullX(0);
      pullY(0);
    });
  });
}
